import SEO from '../Components/SEO';
import Breadcrumb from '../Components/Breadcrumb';
import { ActivityLayout } from '../Components/activity-layout';

const guideImage = '/Images/teacher1-1280x470.webp';

const guideLevels = [
  {
    level: 'start',
    label: 'Getting Started',
    tagline: 'Chapter one',
    cards: [
      {
        title: 'Know Your Students',
        image: '/Images/online-teacher.webp',
        desc: 'Understanding who your students are—their goals, backgrounds, and proficiency levels—is the foundation of effective English teaching.',
        links: [{ text: 'Read Guide', to: '/teach-english/know-your-students' }],
      },
      {
        title: 'Planning a Lesson',
        image: '/Images/1person2.webp',
        desc: 'A practical, modified PPP framework for online and classroom ESL lessons. Covers small talk, warmer, language review, trivia quiz, vocab, reading/video, and discussion questions — with A1–B1 vs B1+ timing breakdown.',
        links: [{ text: 'Read Guide', to: '/teach-english/planning-a-lesson' }],
      },
    ],
  },
  {
    level: 'plan',
    label: 'Planning Lessons',
    tagline: 'Chapter two',
    cards: [
      {
        title: 'Build a Lesson Around a Topic',
        image: '/Images/2people1.webp',
        desc: 'Goal-driven lesson planning starts with a clear, measurable learning outcome and works backward. Learn to write aims that actually guide your activity choices.',
        links: [{ text: 'Read Guide', to: '/teach-english/build-lesson-around-topic' }],
      },
    ],
  },
];

const TeachEnglish = () => {
  return (
    <ActivityLayout
      title="How to Teach English"
      eyebrow="Teaching Guide"
      image={guideImage}
      intro="Teaching English online isn't about having perfect grammar or a fancy certificate. It's about showing up prepared, knowing your students, and running lessons that actually get people talking. This guide walks through the practical stuff — planning lessons that work, keeping your own English sharp, teaching the four skills without overcomplicating it, and simple ways to check progress. No jargon, just what works in real classrooms and video calls."
      seoContent={[
        'Start with the basics: figuring out who your student is, what they need, and where they\'re at. The first lesson is your chance to listen, take notes, and build the relationship that makes everything else easier. Then plan lessons around topics they care about, sequence grammar so it builds naturally, and recycle vocabulary so it actually sticks.',
        'The four skills don\'t need separate textbooks. Reading and video feed discussion. Writing grows from speaking. Quizzes, flashcards, and video tasks are just tools to keep things varied and give students a sense of progress. Pick what fits your student and skip the rest.'
      ]}
      levels={guideLevels}
    >
      <SEO
        title="How to Teach English Online: Practical Guide & Lesson Plans for ESL Teachers"
        description="Complete guide for online ESL teachers. Lesson planning frameworks, classroom management tips, and ready-to-use grammar, reading, speaking, vocabulary, and video resources organized by CEFR level. Free teaching materials included."
        name='English Exam Exercises'
        type='article'
        image={guideImage} />
      <Breadcrumb />
    </ActivityLayout>
  );
};

export default TeachEnglish;
